import GameCard from "./GameCard";

class LocoGameCard extends GameCard{
    constructor(isLucky, pathsID, stateCondition) {
        super(isLucky);
        this.pathsID = pathsID;
        this.stateCondition = stateCondition;
    }
}

export default LocoGameCard;